import { CustomPage } from "../../DashboardApp/types";

// @ts-ignore
import Merchants from "./pages/Merchants/Merchants";

export const customPages = [
	{ moduleId: "b852fb6a-d1bc-4660-8ed3-98d55242a5b5", path: "list", content: <Merchants /> },
] as CustomPage[];
